module.exports = __webpack_public_path__ + "img/modalDelete.94d06e8f.svg";